'use client';

import React, { type FC } from 'react';

import cn from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import usePagination from './Hooks/UsePagination.hook';
import { DEFAULT_LOCALE } from './Locale/DefaultLocale';
import type { PaginationItemProps, PaginationProps } from './Pagination.types';
import { PaginationItem } from './PaginationItem';

import styles from './Styles/Default.module.css';

export const Pagination: FC<PaginationProps> = React.forwardRef<HTMLElement, PaginationProps>(
  (
    {
      totalPages,
      currentPage,
      onClick,
      renderItem = (item: PaginationItemProps) => <PaginationItem {...item} />,
      locale = DEFAULT_LOCALE,
      className,
      ...rest
    },
    ref,
  ) => {
    const classNames = cn(styles.pagination, className);
    const { isDesktop, items } = usePagination({
      onClick,
      totalPages,
      currentPage,
      locale,
    });

    return (
      <nav
        className={classNames}
        ref={ref}
        data-is-desktop-mode={isDesktop ? 'true' : 'false'}
        {...rest}
      >
        <ul>
          {items.map(item => {
            const id = uuidv4();

            return (
              <li key={id}>
                {renderItem({
                  ...item,
                })}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  },
);

Pagination.displayName = 'Pagination';

export default Pagination;
